<template>
  <transition name="fade">
    <b-container v-if="isInfluencer">
      <b-row>
        <b-col cols="12" lg="5" class="pb-3 pb-lg-0">
          <div class="mb-4 mb-md-5">
            <label class="m-0">
              <h4 class="m-0 font-weight-bold">Vello Pricing</h4>
            </label>
            <small class="d-block grey-light">
              Set your price for Vello messages. You also have the option to
              make them FREE or DISABLE them.
            </small>
          </div>

          <b-col class="mb-4 mb-md-5" v-if="package_settings">
            <b-row align-v="center" class="mb-n3">
              <b-col cols="6">
                <strong>Standard Vello</strong>
              </b-col>
              <b-col cols="6" class="text-right">
                <span class="text-right">{{
                  isSinglePackageEnabled ? `Enabled` : `Disabled`
                }}</span>
                <b-form-checkbox
                  switch
                  v-model="package_settings.is_single_pack_enabled"
                  name="eanble_st_vello"
                  class="price-switch float-right"
                  style="margin-top: -5px"
                />
              </b-col>
            </b-row>

            <b-row
              align-h="between"
              align-v="center"
              class="py-2 pack-row single-pack"
              v-if="isSinglePackageEnabled"
            >
              <b-col>
                <b-input-group class="price-group">
                  <template v-slot:prepend>{{ singlePackage.symbol }}</template>
                  <b-form-input
                    ref="standard_vello_price"
                    :value="standard_vello.value"
                    class="text-right"
                    placeholder="0.00"
                    min="0"
                    icon-right="check"
                    :formatter="formatValue"
                    lazy-formatter
                    @change="updatePrice"
                  ></b-form-input>
                </b-input-group>
              </b-col>
            </b-row>
          </b-col>
        </b-col>

        <b-col cols="12" lg="2">
          <div class="price_divider" />
        </b-col>

        <b-col cols="12" lg="5" class="mt-3 mt-lg-0">
          <div class="mb-4 mb-md-5">
            <label class="m-0">
              <h4 class="m-0 font-weight-bold">VIP Pricing</h4>
            </label>
            <small class="d-block grey-light">
              Set pricing for VIP Access
            </small>
          </div>

          <div class="mb-5" v-if="package_settings">
            <span>Enable VIP Access</span>
            <b-form-checkbox
              switch
              v-model="package_settings.is_vip_pack_enabled"
              name="enable_vip"
              class="price-switch float-right"
            />
          </div>

          <div class="vip-pack" v-if="isVipPackageEnabled">
            <span>
              Brief description of your VIP content
              <small>({{ remaining }} characters remaining)</small>
            </span>
            <b-row v-if="package_settings">
              <b-form-group class="col-12 mb-5">
                <b-form-textarea
                  rows="5"
                  v-model="package_settings.vip_description"
                  @keydown="onKeyDown"
                  :max="300"
                  class="form-control effect-26 mt-4 field-vip-pack"
                  placeholder="Unlock exclusive posts and behind the scenes"
                  autofocus
                ></b-form-textarea>
              </b-form-group>
            </b-row>
          </div>

          <div class="mb-2 monthly-subscription" v-if="isVipPackageEnabled">
            <small><strong>Monthly subscription price</strong></small>
          </div>

          <b-row
            class="py-2 pack-row row-monthly-subscription"
            v-if="isVipPackageEnabled"
          >
            <b-col>
              <b-input-group class="price-group">
                <template v-slot:prepend>
                  {{ packages_raw.vip.symbol }}
                </template>
                <b-form-input
                  v-model="packages_raw.vip.price"
                  class="text-right pr-3"
                  placeholder="0.00"
                  type="number"
                  min="0"
                ></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>

          <div class="mt-5" v-if="isVipPackageEnabled">
            <span>Enable Yearly Subscription</span>
            <b-form-checkbox
              switch
              v-model="packages_raw.vip_yearly.is_active"
              name="enable_vip_yearly"
              class="price-switch float-right"
            />
          </div>

          <div class="mt-5 mb-2 yearly-subscription" v-if="isVipYearlyEnabled">
            <small>
              <strong>Yearly subscription price</strong>
            </small>
          </div>

          <b-row
            class="py-2 pack-row row-yearly-subscription"
            v-if="isVipYearlyEnabled"
          >
            <b-col>
              <b-input-group class="price-group">
                <template v-slot:prepend> Apply Discount (%) </template>
                <b-form-input
                  v-model.number="discount"
                  :formatter="formatDiscount"
                  class="text-right pr-3"
                  placeholder="0"
                  type="number"
                  :max="maxDiscount"
                  min="0"
                ></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>

          <small v-if="isVipYearlyEnabled" class="pt-1 float-right">
            {{ yearlyPricePreview }}
          </small>
        </b-col>
      </b-row>

      <b-row v-if="packages_raw">
        <b-col cols="12" md="4" class="m-auto pt-5">
          <b-button
            class="rounded-pill"
            type="submit"
            variant="primary"
            block
            @click="saveChanges"
          >
            <b-spinner small v-if="loading" /> Save Changes
          </b-button>
        </b-col>
      </b-row>
    </b-container>
  </transition>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
export default {
  name: 'EditPricingPage',

  data() {
    return {
      loading: false,
      discount: 0,
      maxDiscount: 90,
      limit: 300,
      standard_vello: {
        price: null,
        value: '',
      },
    }
  },

  computed: {
    ...mapState({
      user: (state) => state.auth.user,
      packages_raw: (state) => state.influencer.packages_raw,
      pricing_minimum: (state) => state.influencer.pricing_minimum,
      package_settings: (state) => state.influencer.package_settings,
    }),
    singlePackage() {
      return this.packages_raw.single
    },
    isInfluencer() {
      return !!(this.user && this.user.influencer_status === 'approved')
    },
    isFreeVelloEnabled() {
      return (
        this.package_settings && this.package_settings.is_free_vello_enabled
      )
    },
    isSinglePackageEnabled() {
      return (
        this.package_settings && this.package_settings.is_single_pack_enabled
      )
    },
    isArEnabled() {
      return (
        this.package_settings && this.package_settings.is_augmented_pack_enabled
      )
    },
    isVipPackageEnabled() {
      return this.package_settings && this.package_settings.is_vip_pack_enabled
    },
    isVipYearlyEnabled() {
      return (
        this.package_settings &&
        this.package_settings.is_vip_pack_enabled &&
        this.packages_raw &&
        this.packages_raw.vip_yearly.is_active
      )
    },
    yearlyPricePreview() {
      if (this.packages_raw) {
        return `${
          this.packages_raw.vip_yearly.symbol
        }${this.getDiscountedPrice()} / year`
      }
      return ``
    },
    remaining() {
      const desc = this.package_settings.vip_description

      if (desc && desc.length > 0) {
        return this.limit - desc.length
      }

      return this.limit
    },
  },

  methods: {
    ...mapActions({
      getPackagePricing: 'influencer/getPackagePricing',
    }),
    ...mapMutations({
      clearPackages: 'influencer/clearPackages',
    }),

    async loadPricing() {
      await this.getPackagePricing(this.user.influencer_uid)

      if (this.packages_raw) {
        this.discount = this.packages_raw.vip_yearly.discount
      }

      if (this.isFreeVelloEnabled) {
        this.standard_vello.value = '0.00 (Free)'
      } else {
        this.standard_vello.value = this.singlePackage.price
      }
    },

    updatePrice(value) {
      this.standard_vello.price = parseFloat(value)
    },

    async saveChanges() {
      this.loading = true

      if (!this.isFreeVelloEnabled) {
        this.singlePackage.price = this.standard_vello.price
      }

      let packages = this.packages_raw
      let packageTypes = Object.keys(packages)
      let newPackagePricing = []
      let hasError = false

      packageTypes.forEach((type) => {
        let newPackage = packages[type]

        if (newPackage instanceof Array) {
          newPackage.forEach((pack, key) => {
            newPackagePricing[key] = {
              package_id: pack.package_id,
              new_price: pack.price,
              new_quantity: pack.quantity,
              is_active: pack.is_active,
            }
          })
        } else {
          if (newPackage.name !== 'AR') {
            newPackagePricing.push({
              package_id: newPackage.package_id,
              new_price: newPackage.price,
              new_quantity: newPackage.quantity,
              new_discount: newPackage.discount,
              is_active: newPackage.is_active,
            })
          }
        }
      })

      if (hasError) {
        this.loading = false
        return
      }

      let params = {
        influencer_uid: this.user.influencer_uid,
        new_package_pricing: newPackagePricing,
      }

      await this.$api
        .post(`influencer/${params.influencer_uid}/package/pricing`, params)
        .then(({ data }) => {
          this.loading = false
          this.showToast('success', data.message)
        })
        .catch((error) => {
          this.loading = false
          this.showToast('danger', error.response.data.message)
        })

      this.updatePriceSettings()
    },

    async updatePriceSettings() {
      await this.$api.post(
        `influencer/${this.user.influencer_uid}/package`,
        this.package_settings
      )

      this.loadPricing()
    },

    showToast(type, message) {
      this.$bvToast.toast(message, {
        variant: type,
        noCloseButton: true,
        toaster: 'b-toaster-bottom-right',
      })
    },

    formatDiscount(val) {
      let discount = val

      if (val === '' || val < 0) {
        discount = 0
      }
      if (val > this.maxDiscount) {
        discount = this.maxDiscount
      }

      this.packages_raw.vip_yearly.discount = discount

      return discount
    },

    getDiscountedPrice() {
      if (this.packages_raw) {
        let monthlyPrice = this.packages_raw.vip.price
        let yearlyPrice = monthlyPrice * 12
        let discounted = yearlyPrice * (this.discount / 100)

        const newPrice = (yearlyPrice - discounted).toFixed(2)
        this.packages_raw.vip_yearly.price = newPrice

        return newPrice
      }

      return 0
    },

    onKeyDown(evt) {
      const desc = this.package_settings.vip_description

      if (desc.length >= this.limit) {
        if (evt.keyCode >= 48 && evt.keyCode <= 90) {
          evt.preventDefault()
        }
      }
    },

    formatValue(value) {
      if (this.isFreeVelloEnabled) {
        return '0.00 (Free)'
      } else {
        return this.setValues(value)
      }
    },

    setValues(value) {
      let price = parseFloat(value)
      if (price < 1 && price > 0) {
        return '0.00 (Free)'
      }
      return price
    },
  },

  watch: {
    standard_vello: {
      deep: true,
      handler(n) {
        if (n.price < 1 && n.price !== null) {
          this.package_settings.is_free_vello_enabled = true
        } else {
          this.package_settings.is_free_vello_enabled = false
        }
      },
    },
  },
  async created() {
    await new Promise((resolve) => setTimeout(resolve, 1000))
    this.loadPricing()
  },
}
</script>

<style lang="scss">
.price-switch {
  width: 4rem;
  padding-left: 4rem;

  .custom-control-label::before {
    top: 0rem;
    height: 2rem;
    left: -3.5rem;
    width: 3.5rem;
    border-radius: 1rem;
    border: none !important;
    box-shadow: none !important;
  }

  .custom-control-label::after {
    top: calc(0.25rem);
    left: calc(-3.25rem);
    width: calc(2rem - 8px);
    height: calc(2rem - 8px);
    border-radius: 1rem;
  }

  .custom-control-input:checked ~ .custom-control-label::before {
    background-color: #52d89f;
  }

  .custom-control-input:checked ~ .custom-control-label::after {
    left: calc(-2.5rem);
  }

  .custom-control-input:disabled ~ .custom-control-label {
    opacity: 0.3;
  }
}

.price-group {
  .input-group-append,
  .input-group-prepend,
  input {
    background: transparent;
    border-color: transparent;
    box-shadow: none;
    outline: none;

    &[type='number'] {
      &::-webkit-inner-spin-button {
        display: none;
      }
      -moz-appearance: textfield;
    }
  }

  .input-group-prepend {
    padding-right: 20px;
    display: flex;
    align-items: center;
  }

  .input-group-append,
  input,
  select {
    background: #000000;
    border-radius: 5px !important;
    height: calc(2rem + 15px);
    padding: 0 5px 0 0;
  }

  select {
    border: none;
    color: #ffffff;
    flex: auto;
    padding-left: 15px;
  }

  .input {
    height: calc(1.5rem + 15px);
    padding: 0 15px 0 0;
  }
}

.pack-row {
  background: #222229;
}

.price_divider {
  border: 15px solid black;
  margin-left: -15px;
  margin-right: -15px;
  opacity: 0.3;
}

@media (min-width: 575px) {
  .price_divider {
    border-width: 2px;
  }
}

@media (min-width: 992px) {
  .price_divider {
    border-width: 2px;
    background: black;
    height: 100%;
    width: 1px;
    margin: auto;
  }
}
</style>
